/* Novedades en la cabecera del Inicio: los títulos añadidos hace poco al catálogo, siempre que el catálogo esté al día
   (si no se ha podido actualizar, lo «nuevo» podría no serlo y no se destaca nada). */

export const NEWS_FRESH_MS = 36 * 3600 * 1000; // catálogo actualizado en las últimas 36 h (se refresca cada día)
export const NEWS_WINDOW_S = 30 * 86400;       // «reciente»: añadido en los últimos 30 días
export const NEWS_MAX = 2;                     // cuántas novedades entran en el carrusel

/**
 * De los candidatos [{ kind, item }] elige las novedades más recientes con imagen. `added` va en segundos.
 * Devuelve [] si el catálogo no está al día.
 */
export function pickNewcomers(all, { now = Date.now(), updatedAt = 0, max = NEWS_MAX } = {}) {
    if (!updatedAt || now - updatedAt > NEWS_FRESH_MS) return [];
    const since = now / 1000 - NEWS_WINDOW_S;
    return (all || [])
        .filter((x) => x && x.item && Number(x.item.added) > since && Number(x.item.added) <= now / 1000 + 86400 && (x.item.backdrop || x.item.poster))
        .sort((a, b) => b.item.added - a.item.added)
        .slice(0, max)
        .map((x) => Object.assign({}, x, { isNew: true }));
}
